module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_pc_2-5b7ee55cb5605679ed8362dd6a2e64ae.jpg";